module.exports = __webpack_public_path__ + "logo_dental_plano_odontologico.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/new_layout/logo_dental_plano_odontologico.svg
 ** module id = 230
 ** module chunks = 0
 **/